import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "warning-tooltip",
  templateUrl: "./warning-tooltip.component.html",
})
export class WarningTooltipComponent {

  @Input() public placement: string = "left";
  @Input() public type: string = "danger";
  @Input() public text: string = "Something went wrong.";

}
